/*
    Header Pin
*/

export default class Headerpin {
    constructor(options = {}) {
        const defaultOptions = {
            header: '.js-headernav',
            duration: 500,
        }

        this.options = {...defaultOptions, ...options};

        this.init();
    }

    init() { 
        const HEADERNAV = document.querySelector(this.options.header);
        const body = document.querySelector('body');
        var d = this.options.duration;
        var data = HEADERNAV.getBoundingClientRect();
        var yOffset = data.top + data.height + pageYOffset;
        var pin = true;

        window.addEventListener('scroll', function() {
            let scroll = window.pageYOffset || document.documentElement.scrollTop;
            if(scroll > yOffset){
                if(pin){
                    HEADERNAV.classList.add('pin');
                    pin = false;
                    animate({
                      duration: d,
                      timing(timeFraction) {
                        return timeFraction;
                      },
                      draw(progress) {
                        HEADERNAV.style.top = (1 - progress)*-1*data.height + 'px';
                      }
                    });

                    body.classList.add('pin-active');
                }
            } else {
                if(!pin){
                    HEADERNAV.classList.remove('pin');
                    HEADERNAV.style.top = '';
                    pin = true;

                    body.classList.remove('pin-active');
                }
            }
        });

        function animate({timing, draw, duration}) {

            let start = performance.now();

            requestAnimationFrame(function animate(time) {
                // timeFraction изменяется от 0 до 1
                let timeFraction = (time - start) / duration;
                if (timeFraction > 1) timeFraction = 1;

                // вычисление текущего состояния анимации
                let progress = timing(timeFraction);

                draw(progress); // отрисовать её

                if (timeFraction < 1) {
                    requestAnimationFrame(animate);
                }

            });
        }
    }
}